var map = {
	"./calendar.svg": "0870",
	"./check.svg": "f75a",
	"./edit.svg": "aa46",
	"./email.svg": "cbb7",
	"./facebook.svg": "40e5",
	"./folder.svg": "d079",
	"./font.svg": "5d85",
	"./garbage.svg": "cee8",
	"./google-plus.svg": "fbc4",
	"./hourglass.svg": "41f3",
	"./images.svg": "b0cb",
	"./layers.svg": "0da3",
	"./link.svg": "18f0",
	"./linkedin.svg": "8540",
	"./lock.svg": "ab00",
	"./picture.svg": "b6c6",
	"./pin.svg": "2dc0",
	"./plus-border.svg": "bfd4",
	"./plus.svg": "2ece",
	"./push-pin.svg": "da75",
	"./search.svg": "8e8d",
	"./send.svg": "94d0",
	"./settings.svg": "3fc8",
	"./share.svg": "5306",
	"./shared.svg": "b599",
	"./show-sidebar-horiz.svg": "5a63",
	"./success.svg": "a8cf",
	"./trash.svg": "ce30",
	"./twitter.svg": "17e7",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";